import axios from "axios";
import { showError } from "../utils/helper/toastHelper";

/**
 * Axios client configured for IPAPI requests
 * Only GET requests are supported.
 */
const ipApiClient = axios.create({
  baseURL: import.meta.env.VITE_IPDATA_BASE_URL,
  timeout: 15000,
});

/**
 * Request interceptor
 * Adds access_key as query param automatically (if available)
 */
ipApiClient.interceptors.request.use(
  (config) => {
    const accessKey = import.meta.env.VITE_IPDATA_ACCESS_KEY;

    if (accessKey) {
      config.params = {
        ...config.params,
        "api-key": accessKey,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Response interceptor
 */
ipApiClient.interceptors.response.use(
  function onFulfilled(response) {
    return response;
  },
  function onRejected(error) {
    if (!error.response) {
      if (error.code === "ECONNABORTED") {
        showError("IPAPI request timeout exceeded");
      } else {
        showError("Network error while fetching IP information.");
      }
      return Promise.reject(error);
    }

    const { status, data } = error.response;

    const message =
      data?.message ||
      data?.error?.info ||
      "Failed to retrieve IP information.";

    switch (status) {
      case 400:
        showError(message || "Invalid IP request.");
        break;

      case 401:
        showError("Invalid or missing IPAPI access key.");
        break;

      case 403:
        showError("IPAPI access restricted.");
        break;

      case 404:
        showError("IP address not found.");
        break;

      case 429:
        showError("IPAPI rate limit exceeded.");
        break;

      case 500:
        showError("IPAPI internal server error.");
        break;

      default:
        showError(message);
        break;
    }

    return Promise.reject(error);
  }
);

export default ipApiClient;